/* Homepage (Design v2, 24 Sep 2026) — behaviour for sections/rr-home-*.liquid.
   Vanilla JS, loaded with defer. Every click is delegated at document level, so sections keep working after
   the theme editor re-renders them. jQuery is used only for the add-to-cart hand-off to the theme's own cart
   drawer (theme.addToCartOk -> inline cart refresh -> theme.RightDrawer.open()), with a fetch fallback. */
(function () {
  "use strict";
  if (window.__rrHomeJS) return;
  window.__rrHomeJS = true;

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  function closest(el, sel) {
    while (el && el.nodeType === 1) { if (el.matches(sel)) return el; el = el.parentElement; }
    return null;
  }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  /* ---------------- smooth scroll to in-page targets (#home-buybox etc.) ---------------- */
  function scrollToHash(hash) {
    if (!hash || hash.charAt(0) !== "#" || hash.length < 2) return false;
    var el = document.getElementById(hash.slice(1));
    if (!el) return false;
    el.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    if (!el.hasAttribute("tabindex")) el.setAttribute("tabindex", "-1");
    try { el.focus({ preventScroll: true }); } catch (e) {}
    return true;
  }
  function linkHash(a) {
    var href = a.getAttribute("href") || "";
    if (href.charAt(0) === "#") return href;
    /* "/#home-buybox" from the shared header while already on the homepage */
    var i = href.indexOf("#");
    if (i > -1) {
      var path = href.slice(0, i).replace(/^https?:\/\/[^/]+/, "") || "/";
      if (path === window.location.pathname) return href.slice(i);
    }
    return null;
  }

  /* ---------------- buy box ---------------- */
  function buyState(core) {
    return { color: core.getAttribute("data-color") || "dove", tier: core.getAttribute("data-tier") || "2" };
  }
  function buySync(core) {
    var st = buyState(core);
    each(core.querySelectorAll(".rrh-buy__img"), function (img) {
      var on = img.getAttribute("data-color") === st.color && img.getAttribute("data-tier") === st.tier;
      if (on) img.removeAttribute("hidden"); else img.setAttribute("hidden", "");
    });
    each(core.querySelectorAll("[data-rrh-color]"), function (b) {
      b.setAttribute("aria-checked", String(b.getAttribute("data-rrh-color") === st.color));
    });
    each(core.querySelectorAll("[data-rrh-tier]"), function (b) {
      b.setAttribute("aria-checked", String(b.getAttribute("data-rrh-tier") === st.tier));
    });
    var name = core.querySelector("[data-rrh-color-name]");
    var sw = core.querySelector('[data-rrh-color="' + st.color + '"]');
    if (name && sw) name.textContent = sw.getAttribute("data-name");
    var tier = core.querySelector('[data-rrh-tier="' + st.tier + '"]');
    var atc = core.querySelector("[data-rrh-atc]");
    var label = core.querySelector("[data-rrh-atc-label]");
    if (atc && tier && !atc.hasAttribute("data-busy-now")) {
      if (!atc.hasAttribute("data-idle")) atc.setAttribute("data-idle", label ? label.textContent : "");
      var avail = tier.getAttribute("data-avail-" + st.color) !== "false";
      atc.disabled = !avail;
      if (label) label.textContent = avail ? atc.getAttribute("data-idle") : "Sold out";
    }
    /* FIX-G: keep the no-JS form's hidden id on the picked variant (homepage box only; NEO2 boxes have no form) */
    var idIn = core.querySelector("input[data-rrh-id]");
    var vid = tier && tier.getAttribute("data-variant-" + st.color);
    if (idIn && vid) idIn.value = vid;
  }
  function currentVariant(core) {
    var st = buyState(core);
    var tier = core.querySelector('[data-rrh-tier="' + st.tier + '"]');
    return tier ? tier.getAttribute("data-variant-" + st.color) : null;
  }
  function addToCart(core, atc) {
    var id = currentVariant(core);
    if (!id || atc.disabled) return;
    var label = core.querySelector("[data-rrh-atc-label]");
    var err = core.querySelector("[data-rrh-atc-error]");
    var idle = atc.getAttribute("data-idle") || (label ? label.textContent : "");
    atc.disabled = true;
    atc.setAttribute("data-busy-now", "1");
    if (label) label.textContent = atc.getAttribute("data-busy") || "Adding…";
    if (err) { err.setAttribute("hidden", ""); err.textContent = ""; }
    function done() { atc.disabled = false; atc.removeAttribute("data-busy-now"); if (label) label.textContent = idle; }
    function fail(msg) {
      done();
      if (err) { err.textContent = msg || "Sorry, something went wrong. Please try again."; err.removeAttribute("hidden"); }
    }
    var $ = window.jQuery;
    if ($ && window.theme && typeof window.theme.addToCartOk === "function") {
      /* same request shape as the theme's product form / theme.addItem: POST /cart/add.js id=…&quantity=1 */
      $.ajax({ type: "POST", url: "/cart/add.js", dataType: "json", data: { id: id, quantity: 1 } })
        .done(function (item) {
          done();
          try { window.theme.addToCartOk(item); } catch (x) { window.location.href = "/cart"; }
        })
        .fail(function (xhr) {
          var d = xhr && xhr.responseJSON;
          fail(d && (d.description || d.message));
        });
      return;
    }
    var body = new FormData();
    body.append("id", id);
    body.append("quantity", "1");
    fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: body })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) { if (res.ok) window.location.href = "/cart"; else fail(res.j && (res.j.description || res.j.message)); })
      .catch(function () { fail(); });
  }

  /* ---------------- video: nothing downloads before a tap (hero: or before the lazy autoplay timer) ---------------- */
  /* A tap-to-play video that gets paused because another one starts is detached (src removed + load()), so it stops
     buffering in the background; pressing its play control again re-attaches the same file at the same position. */
  function detach(v) {
    if (v.hasAttribute("data-rrh-auto") || !v.getAttribute("src")) return;
    v.__rrSrc = v.getAttribute("src");
    v.__rrT = v.currentTime || 0;
    v.removeAttribute("src");
    v.load();
  }
  function reattach(v) {
    if (!v.__rrSrc || v.getAttribute("src")) return;
    var t = v.__rrT || 0;
    v.src = v.__rrSrc;
    v.__rrSrc = null;
    if (t) v.addEventListener("loadedmetadata", function seek() { v.removeEventListener("loadedmetadata", seek); try { v.currentTime = t; } catch (e) {} });
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function pauseOthers(except) {
    each(document.querySelectorAll(".rrh video"), function (v) {
      if (v === except) return;
      if (!v.paused) v.pause();
      detach(v);
    });
  }
  function makeVideo(src, poster, fallback) {
    var v = document.createElement("video");
    v.controls = true;
    v.playsInline = true;
    v.setAttribute("playsinline", "");
    v.setAttribute("webkit-playsinline", "");
    v.preload = "auto";
    if (poster) v.poster = poster;
    v.src = src;
    if (fallback) {
      v.addEventListener("error", function onErr() {
        if (!v.getAttribute("src")) return; /* detached on purpose */
        v.removeEventListener("error", onErr);
        if (v.src !== fallback) { v.src = fallback; var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); }
      });
    }
    v.addEventListener("play", function () { reattach(v); pauseOthers(v); });
    return v;
  }
  function start(v) {
    pauseOthers(v);
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  /* fixed mp4 renditions only (480p phones / 720p desktop): HLS climbed to 1080p and kept fetching while paused */
  function heroSrc(btn, mobile) {
    return mobile ? btn.getAttribute("data-src-mobile") : btn.getAttribute("data-src-desktop");
  }
  function playHero(btn, mobile) {
    var frame = closest(btn, "[data-rrh-hero-frame]") || btn.parentElement;
    var auto = frame.querySelector("video[data-rrh-auto]");
    if (auto) {
      /* the muted loop is already playing: keep its bytes, restart it from the top with sound and controls */
      if (frame.__rrIO) { frame.__rrIO.disconnect(); frame.__rrIO = null; }
      auto.removeAttribute("data-rrh-auto");
      auto.className = "rrh-hero__player";
      auto.loop = false;
      auto.controls = true;
      auto.muted = false;
      auto.defaultMuted = false;
      auto.removeAttribute("muted");
      each(Array.prototype.slice.call(frame.children), function (c) { if (c !== auto) frame.removeChild(c); });
      if (mobile) frame.style.aspectRatio = "1 / 1";
      try { auto.currentTime = 0; } catch (e) {}
      start(auto);
      return;
    }
    var src = heroSrc(btn, mobile);
    if (!src) return;
    var img = btn.querySelector("img");
    var poster = mobile ? "" : (img && (img.currentSrc || img.src)) || "";
    if (poster.indexOf("data:") === 0) poster = "";
    var v = makeVideo(src, poster, btn.getAttribute("data-src-fallback"));
    v.className = "rrh-hero__player";
    frame.innerHTML = "";
    frame.appendChild(v);
    if (mobile) frame.style.aspectRatio = "1 / 1";
    start(v);
  }

  /* Hero lazy muted autoplay (spec 28 Sep). Order: window load -> requestIdleCallback (3 s timeout) -> 2.5 s ->
     IntersectionObserver (>= 50 % of the frame visible) -> <video muted loop playsinline> over the poster, opacity 0 ->
     fade in on "playing". play() rejected / error -> element removed, the poster never moved. Paused off-screen and in
     hidden tabs, resumed on return. Skipped: reduced motion, Save-Data, 2g/slow-2g, phones unless data-autoplay-mobile. */
  var AUTO_DELAY = 2500;
  function heroAutoAllowed(btn, phone) {
    if (reduce || !("IntersectionObserver" in window)) return false;
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ""))) return false;
    return phone ? btn.hasAttribute("data-autoplay-mobile") : btn.hasAttribute("data-autoplay");
  }
  function heroAutoStart(btn, phone, frame) {
    var src = heroSrc(btn, phone);
    if (!src || frame.querySelector("video")) return;
    var v = document.createElement("video");
    v.setAttribute("data-rrh-auto", "");
    v.className = "rrh-hero__auto";
    v.muted = true;
    v.defaultMuted = true;
    v.setAttribute("muted", "");
    v.playsInline = true;
    v.setAttribute("playsinline", "");
    v.setAttribute("webkit-playsinline", "");
    v.loop = true;
    v.autoplay = true;
    v.preload = "none";
    v.setAttribute("aria-hidden", "true");
    v.tabIndex = -1;
    function kill() {
      if (!v.hasAttribute("data-rrh-auto")) return;
      if (frame.__rrIO) { frame.__rrIO.disconnect(); frame.__rrIO = null; }
      var sl = frame.querySelector(".rrh-hero__sound"); if (sl) sl.parentNode.removeChild(sl);
      v.removeAttribute("src"); v.load();
      if (v.parentNode) v.parentNode.removeChild(v);
    }
    v.addEventListener("playing", function () {
      if (!v.hasAttribute("data-rrh-auto")) return;
      v.classList.add("is-on");
      var lbl = btn.getAttribute("data-sound-label");
      if (lbl && !frame.querySelector(".rrh-hero__sound")) {
        var s = document.createElement("span");
        s.className = "rrh-play__label rrh-hero__sound";
        s.setAttribute("aria-hidden", "true");
        s.textContent = lbl;
        frame.appendChild(s);
      }
    });
    v.addEventListener("error", kill);
    v.src = src;
    frame.appendChild(v);
    var p = v.play();
    if (p && p.catch) p.catch(kill);
    return v;
  }
  function initHeroAuto() {
    var btn = document.querySelector(".rrh-hero [data-rrh-video]");
    if (!btn || btn.__rrAuto) return;
    btn.__rrAuto = true;
    var phone = window.matchMedia("(max-width: 767px)").matches;
    if (!heroAutoAllowed(btn, phone)) return;
    var frame = closest(btn, "[data-rrh-hero-frame]");
    if (!frame) return;
    function arm() {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[entries.length - 1];
        var vis = en.isIntersecting && en.intersectionRatio >= 0.5;
        var v = frame.querySelector("video[data-rrh-auto]");
        if (vis && document.visibilityState !== "hidden") {
          if (!v && !frame.querySelector("video")) heroAutoStart(btn, phone, frame);
          else if (v && v.paused) { var pp = v.play(); if (pp && pp.catch) pp.catch(function () {}); }
        } else if (v && !v.paused) v.pause();
      }, { threshold: [0, 0.5, 1] });
      frame.__rrIO = io;
      io.observe(frame);
      document.addEventListener("visibilitychange", function () {
        var v = frame.querySelector("video[data-rrh-auto]");
        if (!v) return;
        if (document.visibilityState === "hidden") v.pause();
        else if (frame.__rrIO) { frame.__rrIO.unobserve(frame); frame.__rrIO.observe(frame); } /* re-evaluate visibility */
      });
    }
    function afterLoad() {
      var wait = function () { setTimeout(arm, AUTO_DELAY); };
      if ("requestIdleCallback" in window) window.requestIdleCallback(wait, { timeout: 3000 });
      else wait();
    }
    if (document.readyState === "complete") afterLoad();
    else window.addEventListener("load", afterLoad, { once: true });
  }
  function playMp4(btn) {
    var box = btn.parentElement;
    var img = btn.querySelector("img");
    var v = makeVideo(btn.getAttribute("data-rrh-mp4"), img && (img.currentSrc || img.src));
    box.replaceChild(v, btn);
    start(v);
  }
  function playVimeo(btn) {
    var id = btn.getAttribute("data-rrh-vimeo");
    if (!id) return;
    var f = document.createElement("iframe");
    f.src = "https://player.vimeo.com/video/" + encodeURIComponent(id) + "?autoplay=1&title=0&byline=0&portrait=0&dnt=1";
    f.allow = "autoplay; fullscreen; picture-in-picture";
    f.setAttribute("allowfullscreen", "");
    f.title = btn.getAttribute("aria-label") || "Video";
    pauseOthers(null);
    btn.parentElement.replaceChild(f, btn);
  }

  /* ---------------- tabs, accordion, rail ---------------- */
  function selectTab(tab) {
    var list = closest(tab, "[role=tablist]");
    if (!list) return;
    each(list.querySelectorAll("[role=tab]"), function (t) {
      var on = t === tab;
      t.setAttribute("aria-selected", String(on));
      t.tabIndex = on ? 0 : -1;
      var p = document.getElementById(t.getAttribute("aria-controls"));
      if (p) { if (on) p.removeAttribute("hidden"); else p.setAttribute("hidden", ""); }
    });
  }
  function toggleAcc(btn) {
    var panel = document.getElementById(btn.getAttribute("aria-controls"));
    var open = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", String(!open));
    if (panel) { if (open) panel.setAttribute("hidden", ""); else panel.removeAttribute("hidden"); }
  }
  function railSync(rail) {
    var t = rail.querySelector("[data-rrh-track]");
    if (!t) return;
    var prev = rail.querySelector('[data-rrh-step="-1"]');
    var next = rail.querySelector('[data-rrh-step="1"]');
    if (prev) prev.disabled = t.scrollLeft <= 4;
    if (next) next.disabled = t.scrollLeft >= t.scrollWidth - t.clientWidth - 4;
  }
  function railStep(rail, dir) {
    var t = rail.querySelector("[data-rrh-track]");
    var tile = t && t.firstElementChild;
    if (!t) return;
    var step = tile ? tile.getBoundingClientRect().width + 16 : t.clientWidth * 0.8;
    t.scrollBy({ left: dir * step, behavior: reduce ? "auto" : "smooth" });
  }

  /* ---------------- delegated events ---------------- */
  /* FIX-G: the homepage ATC is a submit button in a real /cart/add form (no-JS path). With JS the click handler below
     adds via /cart/add.js; this catches any other submit (e.g. Enter) so the page never navigates away. */
  document.addEventListener("submit", function (e) {
    var f = e.target && closest(e.target, "[data-rrh-form]");
    if (!f) return;
    e.preventDefault();
    var core = closest(f, "[data-rrh-buy]"), btn = f.querySelector("[data-rrh-atc]");
    if (core && btn) addToCart(core, btn);
  });
  document.addEventListener("click", function (e) {
    var t = e.target;
    var a = closest(t, "a[href*='#']");
    if (a && (a.hasAttribute("data-rrh-scroll") || closest(a, ".rrh") || closest(a, "[data-rrh-hdr]") || closest(a, ".announcement-bar"))) {
      var h = linkHash(a);
      if (h && scrollToHash(h)) { e.preventDefault(); e.stopPropagation(); return; }
    }
    if (!closest(t, ".rrh")) return;

    var b = closest(t, "[data-rrh-color]");
    if (b) { var c1 = closest(b, "[data-rrh-buy]"); c1.setAttribute("data-color", b.getAttribute("data-rrh-color")); buySync(c1); return; }
    b = closest(t, "[data-rrh-tier]");
    if (b) { var c2 = closest(b, "[data-rrh-buy]"); c2.setAttribute("data-tier", b.getAttribute("data-rrh-tier")); buySync(c2); return; }
    b = closest(t, "[data-rrh-atc]");
    if (b) { e.preventDefault(); addToCart(closest(b, "[data-rrh-buy]"), b); return; }

    b = closest(t, "[data-rrh-video]");
    if (b) { e.preventDefault(); playHero(b, false); return; }
    b = closest(t, "[data-rrh-hero-frame]");
    if (b && b.querySelector("video[data-rrh-auto]")) {
      /* phones with autoplay_mobile: the photo sits under the muted loop, so a tap on the frame means "sound on" */
      var hb = b.querySelector("[data-rrh-video]");
      var wl = closest(b, ".rrh-hero__media");
      var wb = wl && wl.querySelector("[data-rrh-watch]");
      if (hb) { e.preventDefault(); playHero(hb, true); if (wb) wb.setAttribute("hidden", ""); }
      return;
    }
    b = closest(t, "[data-rrh-watch]");
    if (b) {
      e.preventDefault();
      var media = closest(b, ".rrh-hero__media");
      var hv = media && media.querySelector("[data-rrh-video]");
      if (hv) { playHero(hv, true); b.setAttribute("hidden", ""); }
      return;
    }
    b = closest(t, "[data-rrh-mp4]");
    if (b) { e.preventDefault(); playMp4(b); return; }
    b = closest(t, "[data-rrh-vimeo]");
    if (b) { e.preventDefault(); playVimeo(b); return; }

    b = closest(t, "[role=tab]");
    if (b) { selectTab(b); return; }
    b = closest(t, ".rrh-acc__btn");
    if (b) { toggleAcc(b); return; }
    b = closest(t, "[data-rrh-step]");
    if (b) { railStep(closest(b, "[data-rrh-rail]"), parseInt(b.getAttribute("data-rrh-step"), 10)); return; }
  }, true);

  document.addEventListener("keydown", function (e) {
    var tab = closest(e.target, ".rrh [role=tab]");
    if (!tab || (e.key !== "ArrowRight" && e.key !== "ArrowLeft")) return;
    var tabs = Array.prototype.slice.call(closest(tab, "[role=tablist]").querySelectorAll("[role=tab]"));
    var i = tabs.indexOf(tab) + (e.key === "ArrowRight" ? 1 : -1);
    var nxt = tabs[(i + tabs.length) % tabs.length];
    selectTab(nxt); nxt.focus(); e.preventDefault();
  });

  document.addEventListener("scroll", function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.hasAttribute("data-rrh-track")) {
      var rail = closest(t, "[data-rrh-rail]");
      if (rail && !rail.__raf) rail.__raf = requestAnimationFrame(function () { rail.__raf = null; railSync(rail); });
    }
  }, true);

  /* ---------------- Okendo Widget Plus, loaded only near the reviews block ---------------- */
  function loadOkendo(host) {
    if (window.__rrhOkendo) return;
    window.__rrhOkendo = true;
    var s = document.createElement("script");
    s.src = host.getAttribute("data-rrh-okendo");
    s.defer = true;
    document.head.appendChild(s);
  }
  function initOkendo() {
    var host = document.querySelector(".rrh [data-rrh-okendo]");
    if (!host || window.__rrhOkendo) return;
    if (!("IntersectionObserver" in window)) { loadOkendo(host); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); loadOkendo(host); }
    }, { rootMargin: "1200px 0px 1200px 0px" });
    io.observe(host);
  }

  function init() {
    each(document.querySelectorAll(".rrh [data-rrh-buy]"), buySync);
    each(document.querySelectorAll(".rrh [data-rrh-rail]"), railSync);
    initOkendo();
    initHeroAuto();
  }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);
  window.addEventListener("resize", function () { each(document.querySelectorAll(".rrh [data-rrh-rail]"), railSync); });
})();
